export default __webpack_public_path__ + "static/white-nr-desserto-sand-36cad08dc7ce4a47f6a93240ad25600a.jpg";